module.exports = __webpack_public_path__ + "static/img/img-5.b6ad686.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Home/img/img-5.png
// module id = v4Bt
// module chunks = 1